import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

function EmployeeMenuOption({ handleOptionClose, onUpdateClick, current, editRecord, itemsRef }: any) {
    if (current.Status === "Pending") {
        return (
            <Menu
                className="smb-employee-menu"
                id={current.Id}
                open={Boolean(editRecord)}
                anchorEl={itemsRef && itemsRef.current ? itemsRef.current[current.Id] : null}
                keepMounted
                onClose={handleOptionClose}
            >
                <MenuItem className="pointer" key="EDIT" onClick={() => onUpdateClick(current, "EDIT")}>
                    Edit Employee
                </MenuItem>

                <div className="divider-option-line"></div>

                <MenuItem className="pointer" key="RESEND-INVITE" onClick={() => onUpdateClick(current, "RESEND-INVITE")}>
                    Resend Invite
                </MenuItem>

                <div className="divider-option-line"></div>

                <MenuItem key="CANCEL" className="pointer" onClick={() => onUpdateClick(current, "CANCEL")}>
                    Cancel Employee
                </MenuItem>
            </Menu>
        );
    } else if (current.Status === "Incomplete") {
        return (
            <Menu
                className="smb-employee-menu"
                id={current.Id}
                open={Boolean(editRecord)}
                anchorEl={itemsRef && itemsRef.current ? itemsRef.current[current.Id] : null}
                keepMounted
                onClose={handleOptionClose}
            >
                <MenuItem className="pointer" key="EDIT" onClick={() => onUpdateClick(current, "EDIT")}>
                    Edit Employee
                </MenuItem>
            </Menu>
        );
    } else if (current.Status === "Cancelled") {
        return (
            <Menu
                className="smb-employee-menu"
                id={current.Id}
                open={Boolean(editRecord)}
                anchorEl={itemsRef && itemsRef.current ? itemsRef.current[current.Id] : null}
                keepMounted
                onClose={handleOptionClose}
            >
                <MenuItem className="pointer" key="REACTIVATE" onClick={() => onUpdateClick(current, "REACTIVATE")}>
                    Reactivate Employee
                </MenuItem>
            </Menu>
        );
    } else if (current.Status === "Active") {
        return (
            <Menu
                className="smb-employee-menu"
                id={current.Id}
                open={Boolean(editRecord)}
                anchorEl={itemsRef && itemsRef.current ? itemsRef.current[current.Id] : null}
                keepMounted
                onClose={handleOptionClose}
            >
                <MenuItem key="CANCEL" className="pointer" onClick={() => onUpdateClick(current, "CANCEL")}>
                    Cancel Employee
                </MenuItem>
            </Menu>
        );
    } else {
        return <div></div>;
    }
}

export default EmployeeMenuOption;
